


































































import { Component, Prop } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import { Surface, Picture, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import BillingModel from '@/views/Models/BillingModel.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';

@Component({
  components: {
    Surface,
    Picture,
    Typography,
    FilledButton,
    CoinNetworkFeatureTag
  }
})
export default class EmptyState extends BillingModel {
  @Prop() disabled?: boolean;

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return `referralProgram.emptyState`;
  }

  get tButton() {
    if (this.inactiveBilling) return 'buttonUpgrade';
    return 'button';
  }

  onClickCTA() {
    if (this.inactiveBilling) {
      this.onClickUpgrade({
        onSuccess: () => {
          this.gotoReferralCreation();
        },
        props: {
          welcomeCtaText: 'Explore Referral Program',
          origin: 'Empty State Referral Program'
        }
      });
      return;
    }
    this.gotoReferralCreation();
  }

  gotoReferralCreation() {
    this.$analytics({
      eventCategory: 'Referral Program | Empty state',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Create your referral program" button'
    });

    this.$router.push('/referral-program/create');
  }
}
